import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Card,
    Row,
    Col
} from "reactstrap";
import React from 'react';
import styles from './styles.module.scss';

export default function TestimonialCard({
    post,
    key,
    column1 = true,
    column2 = false,
    fullWithColumn = true,
    customClass = "",
}) {
    return (
        <>
            <Card className={`${styles.root} ${customClass}`} key={key}>
                <Row className="m-0">
                    {column1 ?
                        <Col lg={9} className={`${fullWithColumn ? "w-100" : ""} ${column2 ? "mb-5" : "w-100 pe-0 ps-0"}`}>
                            {post?.content ?
                                <div className="description text-white mb-4 pt-5 position-relative" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                : ""}
                            {
                                post.title ?
                                    <>
                                        <div><p className="text-white m-0"><small><strong>{post.title}</strong></small></p></div>
                                    </> : ""
                            }
                            {
                                post.position ?
                                    <>
                                        <div><p className="text-white m-0"><small>{post.position}</small></p></div>
                                    </> : ""
                            }
                        </Col> : ""}
                    {column2 ?
                        <Col lg={3} className={`${fullWithColumn ? "w-100" : ""}`}>
                            <SourceFlowImage
                                src={post.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                size="1000x1000"
                                alt={post?.title}
                                className="card-img rounded-3 shadow"
                                width="100%"
                            />
                        </Col> : ""}
                </Row>

            </Card>
        </>
    )
}